import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { verifyEmail, verifyToken } from "store/actions/authSlice";
import { showAlert } from "store/reducers/alertReducer";
import Spinners from "components/common/Spinners";

const Verification = () => {
    const { search } = useLocation();
    const dispatch = useDispatch();
    const { isLoading } = useSelector((state) => state.auth);

    const calledOnce = useRef(false); // ✅ prevent duplicate calls

    useEffect(() => {
        if (calledOnce.current) return; // skip if already called
        calledOnce.current = true;

        const queryParams = new URLSearchParams(search);
        const token = queryParams.get("token");

        if (token) {
            dispatch(verifyToken({ token }))
                .then((action) => {
                    const { statusCode, success, message, data } = action?.payload || {};
                    if (statusCode === 200 && success) {
                        dispatch(showAlert({ text: message, type: "success" }));
                        localStorage.removeItem("signupFormData");
                        localStorage.removeItem("hasAgreedTnC");
                        setTimeout(() => {
                            window.close();
                        }, 1500);
                    } else {
                        dispatch(showAlert({ text: message, type: "error" }));
                    }
                })
                .catch(() => {
                    dispatch(showAlert({ text: "Something went wrong", type: "error" }));
                });
        } else {
            console.log("No token found in URL.");
        }
    }, [search, dispatch]);

    return (
        <div className="welcome_pg">
            <div className="container position-relative">
                <div className="tcp_inner">
                    <div className="left">{<Spinners />}</div>
                </div>
            </div>
        </div>
    );
};

export default Verification;
